import { CreditCardIcon, FolderArrowDownIcon, HomeIcon, PaintBrushIcon, ShoppingBagIcon, ShoppingCartIcon } from "@heroicons/react/24/outline";
import Sidebar from "../../../empreenderUI/SideBar";
import ItemIcon from "../../../empreenderUI/ui/ItemIcon";
import ItemMenu from "../../../empreenderUI/ui/ItemMenu";
import ItemText from "../../../empreenderUI/ui/ItemText";
import Separator from "../../../empreenderUI/ui/Separator";
import { useHistory } from "react-router-dom";
import ContentApp from "../../../empreenderUI/ContentApp";
import Content from "../../../empreenderUI/Content";
import TopBarContent from "../../../empreenderUI/TopBarContent";
import PerfilMenu from "../../../empreenderUI/ui/PerfilMenu";
import { Button } from "../../../empreenderUI/ui/Button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../empreenderUI/ui/Select/Select";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";

import IntegracaoBtn from "../../../empreenderUI/ui/SideBarBtns/IntegracaoBtn";
import { HardDrive, Key, LogOut, Unplug } from "lucide-react";
import SairBtn from "../../../empreenderUI/ui/SideBarBtns/SairBtn";
import AssinaturaBtn from "../../../empreenderUI/ui/SideBarBtns/AssinaturaBtn";
import { useSelector } from "react-redux";
import { translations } from "../../../utils/language";
import { getCurrentHostWithPortAndProtocol } from "../../../utils/shopify-login";
import PersonalizarMenu from "../../../modules/thema/pages/personalizar/PersonalizarMenu";
import CheckoutContent from "../../../modules/thema/pages/personalizar/contents/CheckoutContent";
import PageCheckoutContent from "../../../modules/thema/pages/personalizar/contents/PageCheckoutContent";
import EmailContent from "../../../modules/thema/pages/personalizar/contents/EmailContent";
import MarcaAguaContent from "../../../modules/thema/pages/personalizar/contents/MarcaAguaContent";
import PersonalizarRouteSync from "../../../modules/thema/pages/personalizar/PersonalizarRouteSync";

const COUNTRY_OPTIONS = {
    BR: {
        value: "BR",
        language: "pt",
        label: "Brasil",
        flag: "https://flagcdn.com/w40/br.png",
    },
    MX: {
        value: "MX",
        language: "es",
        label: "México",
        flag: "https://flagcdn.com/w40/mx.png",
    },
    AR: {
        value: "AR",
        language: "es",
        label: "Argentina",
        flag: "https://flagcdn.com/w40/ar.png",
    },
};

const LayoutUI = (props) => {

    const history = useHistory()
    const dispatch = useDispatch()

    const language = useSelector((state) => state.reducerLanguage);

    let user = JSON.parse(localStorage.getItem("depoimentos@login"));

    let token = user?.access_token.token;
    let tokenType = user?.access_token.type;

    useEffect(() => {
        const storageLanguage = localStorage.getItem("language");
        if (storageLanguage) {
            dispatch({ type: "SAGA_LIST_LANGUAGE", payload: { language: storageLanguage, }, });
        } else {
            dispatch({ type: "SAGA_LIST_LANGUAGE", payload: { language: "pt", }, });
        }
    }, [localStorage, dispatch]);

    const [isOpenMenu, setIsOpenMenu] = useState(localStorage.getItem("isOpenMenu") == null || localStorage.getItem("isOpenMenu") == undefined ? true : localStorage.getItem("isOpenMenu"))
    const [country, setCountry] = useState(() => {
        const stored = localStorage.getItem("country");
        return COUNTRY_OPTIONS[stored] ? stored : "BR";
    });

    useEffect(() => {
        const menu = document.getElementById("sidebar_trigger");
        if (menu) { menu.addEventListener("click", (handleClick)) }
        return () => { if (menu) { menu.removeEventListener("click", handleClick); } };
    }, []);

    const handleClick = (event) => {
        if (localStorage.getItem("isOpenMenu") == "true") {
            localStorage.setItem("isOpenMenu", "false")
            setIsOpenMenu(localStorage.getItem("isOpenMenu"))
        } else {
            localStorage.setItem("isOpenMenu", "true")
            setIsOpenMenu(localStorage.getItem("isOpenMenu"))
        }
    };

    useEffect(() => {
        console.log("language", language)
    }, [language])

    const handleCountryChange = (value) => {
        const option = COUNTRY_OPTIONS[value];
        if (!option) return;

        setCountry(value);
        localStorage.setItem("country", option.value);
        localStorage.setItem("language", option.language);
        dispatch({
            type: "SAGA_LIST_LANGUAGE",
            payload: { language: option.language },
        });
        window.location.reload();
    };

    const handleLogout = () => {
        try {
            localStorage.removeItem("depoimentos@login");
            window.location.href = getCurrentHostWithPortAndProtocol()+'/login'
        } catch (error) { }
    };
    return (
        <Sidebar
            idioma={language.data == "pt" || language.data == "pt-br" ? "pt-br" : "es-mx"}
            appEndPoint={process.env.REACT_APP_API_URL}
            headers={{ "Content-Type": "application/json", Authorization: tokenType + " " + token, }}
            app={"Dijital"}
            hideApps={user && user?.user?.shopify_store_id > 0 ? true : false}
            isOpen={isOpenMenu == "false" ? false : true}
            chave_empreender={user?.user?.chave_empreender}
        >
            <TopBarContent>
                <div className="w-[100px]">
                    <Select value={country} onValueChange={handleCountryChange}>
                        <SelectTrigger>
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {Object.values(COUNTRY_OPTIONS).map((option) => (
                                <SelectItem key={option.value} value={option.value} textValue={option.label}>
                                    <img
                                        src={option.flag}
                                        alt={option.label}
                                        width="20"
                                        height="15"
                                        className="rounded-[2px] object-cover shadow-sm"
                                    />
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            </TopBarContent>

            <ItemMenu
                asChild
                isActive={window.location.pathname == "/" ? true : false}>
                <Link to={"/"}>
                    <ItemIcon>
                        <HomeIcon />
                    </ItemIcon>
                    <ItemText>{translations["sidebar-inicio"][language.data]}</ItemText>
                </Link>

            </ItemMenu>


            <ItemMenu
                asChild
                isActive={window.location.pathname == "/produtos" || window.location.pathname.includes("/variacoes") ? true : false}>
                <Link to={"/produtos"}>
                    <ItemIcon>
                        <ShoppingBagIcon />
                    </ItemIcon>
                    <ItemText>{translations["sidebar-produtos"][language.data]}</ItemText>
                </Link>

            </ItemMenu>

            <ItemMenu
                onClick={() => { history.push("/galeria") }}
                isActive={window.location.pathname == "/galeria" ? true : false}>
                <ItemIcon>
                    <FolderArrowDownIcon />
                </ItemIcon>
                <ItemText>{translations["sidebar-galeria"][language.data]}</ItemText>
            </ItemMenu>

            <ItemMenu
                onClick={() => { history.push("/pedidos"); }}
                isActive={window.location.pathname == "/pedidos" || window.location.pathname.replace(/\d+/g, "").includes("pedidos//produtos") ? true : false}>
                <ItemIcon>
                    <ShoppingCartIcon />
                </ItemIcon>
                <ItemText>{translations["Pedidos"][language.data]}</ItemText>
            </ItemMenu>

            <Separator>{translations["sidebar-configuracoes"][language.data]}</Separator>

            <ItemMenu
                id="personalizar"
                onClick={() => { history.push("/personalizar"); }}
                isActive={window.location.pathname.includes("/personalizar")}>
                <ItemIcon>
                    <PaintBrushIcon />
                </ItemIcon>
                <ItemText>{translations["Personalizar"][language.data]}</ItemText>
            </ItemMenu>

            <ItemMenu
                onClick={() => { history.push("/seguranca"); }}
                isActive={window.location.pathname === "/seguranca"}>
                <ItemIcon>
                    <Key strokeWidth={1.5} />
                </ItemIcon>
                <ItemText>{translations["thema-seguranca"]?.[language.data] || "Segurança"}</ItemText>
            </ItemMenu>

            <ItemMenu
                onClick={() => { history.push("/armazenamento"); }}
                isActive={window.location.pathname === "/armazenamento"}>
                <ItemIcon>
                    <HardDrive strokeWidth={1.5} />
                </ItemIcon>
                <ItemText>{translations["Armazenamento"]?.[language.data] || "Armazenamento"}</ItemText>
            </ItemMenu>

            <IntegracaoBtn onClick={() => { history.push("/integracoes") }} isActive={window.location.pathname === '/integracoes'}>
                <ItemIcon>
                    <Unplug name="intregacoes" />
                </ItemIcon>
                <ItemText>{translations["sidebar-integracoes"][language.data]}</ItemText>
            </IntegracaoBtn>


            <PerfilMenu>
                <Button
                    onClick={handleLogout}
                    className="text-gray-800 text-xs font-normal">
                    {translations["Sair"][language.data]}
                </Button>

                <AssinaturaBtn>
                    <ItemMenu asChild preventDefault>
                        <Link to="/pagamentos">
                            <ItemIcon>
                                <CreditCardIcon />
                            </ItemIcon>
                            <ItemText skipSidebar>{translations["sidebar-pagamentos"][language.data]}</ItemText>
                        </Link>
                    </ItemMenu>
                </AssinaturaBtn>

                <SairBtn>
                    <ItemMenu asChild>
                        <span onClick={handleLogout}>
                            <ItemIcon>
                                <LogOut strokeWidth={1.5} />
                            </ItemIcon>
                            <ItemText skipSidebar>{translations["Sair"][language.data]}</ItemText>
                        </span>
                    </ItemMenu>
                </SairBtn>
            </PerfilMenu>

            <Content id="personalizar">
                <PersonalizarMenu />
            </Content>
            <Content id="checkout">
                <CheckoutContent />
            </Content>
            <Content id="page-checkout">
                <PageCheckoutContent />
            </Content>
            <Content id="email">
                <EmailContent />
            </Content>
            <Content id="marca-agua">
                <MarcaAguaContent />
            </Content>

            <ContentApp>
                <PersonalizarRouteSync />
                <div style={{ padding: "20px 0px 60px 0px", width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                    {props.children}
                </div>
            </ContentApp>

        </Sidebar>
    )
}

export default LayoutUI
